module.exports = __webpack_public_path__ + "img/image-01.99db0ade.jpeg";